import { Form, Radio } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

const GenderSelector = ({ showOther, ...props }) => {
  const { t } = useTranslation('common');
  
  return (
    <Radio.Group {...props}>
      <Radio value={'F'}>{t('genders.F')}</Radio>
      <Radio value={'M'}>{t('genders.M')}</Radio>
      {showOther && <Radio value={'0'}>{t('genders.O')}</Radio>}
    </Radio.Group>
  );
};

export default memo(GenderSelector);

GenderSelector.propTypes = {
  showOther: PropTypes.bool
};

GenderSelector.defaultProps = {
  showOther: false
};

// eslint-disable-next-line react/prop-types
export const renderGenderSelector = ({ formItemProps, field }) => {
  
  return (
    // eslint-disable-next-line react/prop-types
    <Form.Item {...formItemProps} required={field?.required}>
      <GenderSelector {...field}/>
    </Form.Item>
  );
};
